export default __webpack_public_path__ + "4782a4ff309527d87c89d77a25b3f9e2.png";